module.exports = __webpack_public_path__ + "img/05529929000398.02157579.png";